import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PaginatedResponse, ProjectModel } from '@core/models/project.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectApiService {
  private http = inject(HttpClient);

  public createOrUpdateProject(data: any, id: string | null = null): Observable<any> {
    const baseUrl = `${environment.apiUrl}/${environment.apiVersion}/projects/`;
    const url = id ? `${baseUrl}${id}/` : baseUrl;
    const method = id ? 'patch' : 'post';

    return this.http[method](url, data);
  }

  public updateProjectThumbnail(id: string | undefined, thumbnailId: string | null = null, data: FormData) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/projects/${id}/thumbnails/${thumbnailId}/`;

    return this.http.put(url, data);
  }

  public getProjects(id = '', company = '', page = 1, page_size = 15, construction?: boolean): Observable<any> {
    const qry: any = {
      page,
      page_size,
    };

    if (construction !== undefined && construction !== null) {
      qry.with_construction = construction;
    }

    if (id) {
      qry.user_id = id;
    }
    if (company) {
      qry.company_id = company;
    }

    const params = new HttpParams({ fromObject: qry });
    const url = `${environment.apiUrl}/${environment.apiVersion}/projects`;

    return this.http.get(url, { params });
  }

  public getPinnedProjects(id: string) {
    return this.http.get<PaginatedResponse<{ construction_project_id: string }>>(
      `${environment.apiUrl}/${environment.apiVersion}/pin_construction_projects/`,
      { params: { user_id: id } },
    );
  }

  public pinProject(id: string, pinned: boolean): Observable<PaginatedResponse<ProjectModel>> {
    return this.http.put<PaginatedResponse<ProjectModel>>(
      `${environment.apiUrl}/${environment.apiVersion}/pin_construction_projects/${id}/`,
      { is_pinned: pinned },
    );
  }

  public getSingleProject(id: string | null | undefined): Observable<{ data: ProjectModel }> {
    const url = `${environment.apiUrl}/${environment.apiVersion}/projects/${id}/`;

    return this.http.get<{ data: ProjectModel }>(url);
  }
}
